<template>
	<header class="app-header">
		<nav :aria-label="$t('auth-header-nav-label')">
			<ul class="app-header-bar">
				<li class="app-header-logo">
					<a href="/">
						<img
							:alt="$t('header-logo-alt')"
							src="@/shared/assets/img/supd-logo.svg"
							height="84"
							width="258"
						/>
					</a>
				</li>

				<li class="u-list u-list--lg">
					<TAction appearance="link" to="/">
						{{ $t('home-page-header-home-link') }}
					</TAction>

					<TAction
						appearance="tertiary"
						@click="logout(win.location.origin, true)"
					>
						<SignOutIcon />
						{{ $t('global-logout') }}
					</TAction>
				</li>
			</ul>
		</nav>
	</header>
</template>

<script setup lang="ts">
import TAction from '@/app/common/TAction.vue'
import SignOutIcon from '@/shared/icons/SignOutIcon.vue'
import { logout } from '@/utilities/logout'

const win = window
</script>

<style scoped>
.app-header {
	--auth-header-block-spacing: var(--size-20);

	border-block-end: var(--size-1) solid var(--c-grey-200);
	padding-inline: var(--auth-header-edge-inline-spacing);
}

.app-header-bar {
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	gap: var(--size-24);
	padding-block: var(--auth-header-block-spacing);
}

.app-header-logo {
	margin-inline-end: auto;
}

@media (width < 68rem) {
	.app-header {
		--auth-header-block-spacing: var(--size-12);
	}
}

@media print {
	.app-header {
		display: none !important;
	}
}
</style>
